import { useEffect } from 'react';
import { IMap } from 'typings/DeepIMap';
import { BoxPropertySide } from 'const';
import { getActiveLayer } from 'hooks/useActiveLayer';
import * as Models from 'models';
import { toImmutable } from 'utils/immutable';
import { TextOwnProps } from '../models';
import useCell from './useCell';
import useStyles from './useStyles';

export function usePaddingEffect(
  relation: TextOwnProps['relation'],
  layoutRelations: TextOwnProps['layoutRelations'],
  stylesHook: ReturnType<typeof useStyles>,
  cellHook: ReturnType<typeof useCell>,
  isAutoFitContent: boolean,
): void {
  useEffect(() => {
    const activeLayer = getActiveLayer();
    const oldPadding = relation.getIn(['styles', activeLayer, 'padding']);
    let relationsWithUpdatedStyles;
    if ((oldPadding.get(BoxPropertySide.TOP) !== stylesHook.styles.padding?.get(BoxPropertySide.TOP)
      || oldPadding.get(BoxPropertySide.BOTTOM) !== stylesHook.styles.padding?.get(BoxPropertySide.BOTTOM))
      && isAutoFitContent) {
      // update relation with new padding before performing calculation to ensure right height
      const newPadding = toImmutable({
        bottom: stylesHook.styles.padding?.get(BoxPropertySide.BOTTOM),
        left: stylesHook.styles.padding?.get(BoxPropertySide.LEFT),
        right: stylesHook.styles.padding?.get(BoxPropertySide.RIGHT),
        top: stylesHook.styles.padding?.get(BoxPropertySide.TOP),
      });
      const relationWithUpdatedPadding = relation.setIn(['styles', activeLayer, 'padding'], newPadding);
      relationsWithUpdatedStyles = layoutRelations.set(
        relation.get('id'),
        relationWithUpdatedPadding as unknown as IMap<Models.LayeredRegularRelation<Models.CombinedRelationStyles>>);
    }

    cellHook.resetHeight(relationsWithUpdatedStyles);
  }, [
    stylesHook.styles.padding?.get(BoxPropertySide.TOP),
    stylesHook.styles.padding?.get(BoxPropertySide.BOTTOM),
    isAutoFitContent,
  ]);
}
